import {Component, EventEmitter, inject, OnInit, Output} from '@angular/core';
import {AsyncPipe, DatePipe} from "@angular/common"; // NgIf, NgForOf, NgClass hier importieren
import {MatButtonModule} from "@angular/material/button";
import {MatDividerModule} from "@angular/material/divider";
import {MatIconModule} from "@angular/material/icon";
import {Router} from "@angular/router";
import {MatSlideToggleModule} from "@angular/material/slide-toggle"; // Als Modul importieren
import {BehaviorSubject, combineLatest, map, Observable} from "rxjs";

import {Notification} from "../../../models/notification.model";
import {NotificationService} from "../../../services/notification.service";

@Component({
  selector: 'app-notification-panel',
  standalone: true,
  imports: [
    AsyncPipe,
    DatePipe,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatSlideToggleModule
  ],
  templateUrl: './notification-panel.component.html',
  styleUrl: './notification-panel.component.scss'
})
export class NotificationPanelComponent implements OnInit {
  @Output() close = new EventEmitter<void>();

  private notificationService = inject(NotificationService);
  private router = inject(Router);

  private showRead = new BehaviorSubject<boolean>(false);
  public showRead$ = this.showRead.asObservable();

  public displayedNotifications$!: Observable<Notification[]>;

  ngOnInit(): void {
    this.displayedNotifications$ = combineLatest([
      this.notificationService.notifications$,
      this.showRead$
    ]).pipe(
      map(([notifications, showRead]) => {
        if (showRead) {
          return notifications;
        }

        return notifications.filter(n => !n.read);
      })
    );
    }

  onNotificationClick(notification: Notification): void {
    const navigateAndClose = () => {
      if (notification.link) {
        this.router.navigateByUrl(notification.link);
        this.close.emit();
      }
    };

    if (!notification.read) {
      this.notificationService.markAsRead(notification.id).subscribe(() => {
        navigateAndClose();
      });
    } else {
      navigateAndClose();
    }
  }

  onMarkAllAsRead(): void {
    this.notificationService.markAllAsRead().subscribe();
  }

  toggleShowRead(): void {
    this.showRead.next(!this.showRead.value);
  }
}
